import { DraggerProps } from 'antd/lib/upload/Dragger';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { BaseDndUploader } from 'components/ui';
import { BaseDndUploaderProps } from 'components/ui/BaseDndUploader';
import {
  UploaderState,
  useUploadFormStore,
} from 'stores/local/forms/UploadFormStore';

import s from './DndUploader.module.scss';
import {
  ErrorFileState,
  InitialFileState,
  SuccessFileState,
  UploadingFileState,
} from './components';

type DndUploaderProps = DraggerProps;

const UPLOADER_RENDERER: Record<UploaderState, React.ComponentType> = {
  [UploaderState.uploaded]: SuccessFileState,
  [UploaderState.initial]: InitialFileState,
  [UploaderState.loading]: UploadingFileState,
  [UploaderState.error]: ErrorFileState,
};

/**
 * Компонент для загрузки файлов
 * @constructor
 */
const DndUploader: React.FC<DndUploaderProps> = () => {
  const store = useUploadFormStore();

  const draggerProps = React.useMemo((): BaseDndUploaderProps => {
    return {
      name: 'file',
      containerClassName: s.uploader,
      maxCount: 1,
      customRequest: store.upload,
      fileList: [],
    };
  }, [store.upload]);

  const Component = UPLOADER_RENDERER[store.uploaderState];

  return (
    <BaseDndUploader {...draggerProps}>
      <Component />
    </BaseDndUploader>
  );
};

export default observer(DndUploader);
